import { render, staticRenderFns } from "./WallElementsItem.vue?vue&type=template&id=c8a00e8c&scoped=true&"
import script from "./WallElementsItem.vue?vue&type=script&lang=js&"
export * from "./WallElementsItem.vue?vue&type=script&lang=js&"
import style0 from "./WallElementsItem.vue?vue&type=style&index=0&id=c8a00e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a00e8c",
  null
  
)

export default component.exports